import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-lock",
  "use": "foquz-icon-lock-usage",
  "viewBox": "0 0 11 12",
  "content": "<symbol viewBox=\"0 0 11 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-lock\"><path d=\"M3 5.5v-2a2.5 2.5 0 115 0v2m-6 0h7a1 1 0 011 1V10a1 1 0 01-1 1H2a1 1 0 01-1-1V6.5a1 1 0 011-1z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol